import { z } from 'zod';
import { createPartialStrictObjectSchemaWithAtLeastOneProperty } from '../PartialStrictObjectSchema.ts';
import { validateState } from '../ValidateState.ts';
export const MIN_BARBARIAN_PROGRESS = 0;
export const MAX_BARBARIAN_PROGRESS = 7;
export const mechanicBarbarianInvasionStateSchema = z.object({
    barbarianProgress: z.number().int().min(MIN_BARBARIAN_PROGRESS).max(MAX_BARBARIAN_PROGRESS),
    didBarbariansAttackOnce: z.boolean()
}).strict();
export function validateMechanicBarbarianInvasionState(data) {
    return validateState(mechanicBarbarianInvasionStateSchema, data);
}
export const mechanicBarbarianInvasionStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(mechanicBarbarianInvasionStateSchema);
